module.exports = __webpack_public_path__ + "img/1.29810659.png";